import { Button, Grid } from "@mui/material";
import { Formik, Field, Form } from "formik";
import { TextField } from "formik-mui";

import { useTranslation } from "react-i18next";
import { APIError } from "src/types";
import { ServerErrors } from "src/components/form-components/ServerErrors";
import { ButtonGrid } from "src/components/form-components/ButtonGrid";
import { ButtonLoading } from "src/components/ButtonLoading";
import { useLoginSchema } from "src/schemas/login.schema";
import { Link } from "react-router-dom";

export type LoginFormData = { email: string; password: string };

interface Props {
  onSubmit: (values: LoginFormData) => void;
  isLoading: boolean;
  errors?: APIError[] | Error | null;
}

export function LoginForm(props: Props) {
  const { t } = useTranslation();
  const validationSchema = useLoginSchema();
  return render();

  function render() {
    return (
      <Formik initialValues={{ email: "", password: "" }} validationSchema={validationSchema} onSubmit={props.onSubmit}>
        {({ isSubmitting }) => (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Field component={TextField} label={t("label.email")} name="email" variant="standard" autoFocus />
              </Grid>

              <Grid item xs={12}>
                <Field
                  component={TextField}
                  label={t("label.password")}
                  type="password"
                  name="password"
                  variant="standard"
                />
              </Grid>

              {props.errors && (
                <Grid item xs={12}>
                  <ServerErrors data={props.errors} />
                </Grid>
              )}

              <ButtonGrid container item xs={12} sx={{ justifyContent: "flex-start" }}>
                <ButtonLoading
                  isLoading={isSubmitting || props.isLoading}
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  {t("label.login")}
                </ButtonLoading>

                <Button variant="text" disabled={isSubmitting} component={Link} to="/password/forgot">
                  {t("label.forgotPassword")}
                </Button>
              </ButtonGrid>
            </Grid>
          </Form>
        )}
      </Formik>
    );
  }
}
